import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    container:
      'flex items-center justify-center gap-3 max-lg:justify-start max-sm:gap-5.5',
    value: 'sm:heading-3xl heading-3xl leading-none !font-[450]',
    starsContainer: 'gap-5.5 max-sm:gap-7',
    star: 'size-7'
  }
});
